/* eslint-disable camelcase */
import React from 'react'
// import BistroMenuItem from './BistroMenuItem';
import lodgerentalStyles from './lodgerental.module.sass'

export default props => {
  const { show, rental_title, text, seasonal_prices } = props.lodgerental

  // const { title } = this.props.announcement
  // const { show } = this.props.announcement
  // const { show } = this.props.announcement

  if (props.lodgerental) {
    return (
      <div className={lodgerentalStyles.lodgerental}>
        <div className={lodgerentalStyles.content}>
          <h3 className={lodgerentalStyles.title}>{rental_title}</h3>
          <p className={lodgerentalStyles.text}>{text}</p>

          <ul className={lodgerentalStyles.list}>
            {seasonal_prices.map(item => (
              <li
                key={item.date_range}
                className={lodgerentalStyles.seasonalrate}
              >
                {item.date_range}{' '}
                <span className={lodgerentalStyles.itemprice}>
                  ${item.price}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

// lodgerental {
//   show
//   title
//   text
//   seasonal_prices {
//     date_range
//     price
//   }
// }
